import React, {PropTypes} from 'react';
import TextField from '../../common/TextField/TextField';
import PhoneField from '../../common/PhoneField/PhoneField';
import PlaceField from '../../common/PlaceField/PlaceField';
import Checkbox from '../../common/Checkbox/Checkbox';
import './AddressForm.less';

class AddressForm extends React.Component {
  render () {
    const {address, onChange, addressMap, validationRun, validityMap} = this.props;

    return (
      <form className="address-form">
        <PlaceField value={address.streetAddress}
          label="Ulica"
          onPlaceChanged={onChange}
          placeholder="Adres albo Nazwa Firmy"
          valid={validityMap.streetAddress}
          validationRun={validationRun} />
        {addressMap}
        <TextField value={address.deliveryInfo} label="Informacja dla dostawcy" onChange={deliveryInfo => {onChange && onChange({deliveryInfo});}}/>
        <PhoneField value={address.phone}
          label="Telefon"
          onChange={phone => {onChange && onChange({phone});}}
          valid={validityMap.phone}
          validationRun={validationRun}/>
        <Checkbox checked={address.piAgreed}
          className="accept-policy-checkbox" label={
              <span>Wyrażam zgodę na przetwarzanie moich danych osobowych.<br/>
                <a href="#">Regulamin</a></span>}
          onChange={piAgreed => {onChange && onChange({piAgreed});}}
          valid={validityMap.piAgreed}
          validationRun={validationRun} />
      </form>
    );
  }
}

AddressForm.propTypes = {
  address: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  addressMap: PropTypes.node,
  validationRun: PropTypes.number,
  validityMap: PropTypes.object
};

export default AddressForm;



// WEBPACK FOOTER //
// ./src/components/OrderModal/AddressStep/AddressForm.js